import * as React from "react";
import Button from "../components/connect-ui/Button";
import { SimpleTextPhase } from "../components/SimpleTextPhase";
import useCloseClickHandler from "../hooks/useCloseClickHandler";
export default function NoPoliciesOrQuotesFoundPhase() {
    var closeClickHandler = useCloseClickHandler();
    function handleCloseClick() {
        closeClickHandler();
    }
    return (React.createElement(SimpleTextPhase, { title: "No Quotes Found" },
        React.createElement("p", { className: "-mt-10 text-center text-lg leading-normal" }, "Sorry - we are unable to find quotes for you at this time."),
        React.createElement(Button, { className: "mt-12", type: "button", onClick: handleCloseClick }, "Close")));
}
